var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"max-width":"800px","min-width":"600px"}},[_c('h2',[_vm._v("提供意見")])])}
var staticRenderFns = []

export { render, staticRenderFns }